import { Thead, Table } from '@chakra-ui/react';
import styled from '@emotion/styled';

export const TableHeading = styled(Thead)`
  color: #555c72;
  font-weight: bold;
  background: #f8f8f8;


  th {
    text-transform: none;
    padding: 16px 16px; 
    position: sticky;
    top: 0;
    left: 0;
    background: #f8f8f8;
  }
`;

export const TableElement = styled(Table)`
  td,
  th {
    padding: 8px 16px;
  }
  tr {
    border-bottom: 1px solid #e4e8ef;
  }
`;
